import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { radius, borders } from '@/styles/Themes/Metrics';
import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';
import { Transition } from '@/styles/Themes/KeyFrames';

export const Container = styled.a`
    display: flex;
    flex-direction: column;
    background: ${cssVars.bg_white_dark3};
    box-shadow: ${cssVars.shadow_card_default};
    border-radius: ${radius.small};
    padding: 14px 12px 0;

    ${Screen.ipad} {
        max-width: 100%;
    }
    ${Screen.desktop} {
        max-width: 520px;
        padding: 10px 9px 0;
    }
    > a {
        > span {
            position: initial;
            color: ${cssVars.fg_gray1_white};
            display: block;
        }
    }

    &:hover {
        box-shadow: ${cssVars.shadow_card_hover};
        ${Transition.normal};
    }
`;

export const ImgWrap = styled.div`
    position: relative;
    display: flex;
    border-radius: ${radius.small};
    overflow: hidden;
    height: 187px;

    ${Screen.ipad} {
        height: 326px;
        border-radius: ${radius.small};
    }

    ${Screen.desktop} {
        height: 255px;
    }
`;

export const Gradient = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(
        180deg,
        rgba(20, 19, 19, 0) 31.6%,
        rgba(0, 0, 0, 0.052) 73.45%
    );
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const DescriptionWrapper = styled.div`
    flex: 1;
    padding: 8px;

    ${Screen.ipad} {
        padding: 12px;
    }

    ${Screen.desktop} {
        padding: 16px;
    }
`;

export const Date = styled.span`
    background-color: ${Palette.white.normal};
    color: ${Palette.gray.normal};
    position: absolute;
    top: 0px;
    left: 0px;
    margin: 12px 0 0 12px;
    padding: 5px 15px;
    border-radius: ${radius.button};
    ${Text.Full.medium.semibold}
    height: 28px;
    ${Text.Full.medium.semibold}
    ${Screen.desktop} {
        height: 24px;
        padding: 3px 15px;
    }
`;

export const Title = styled.span`
    color: ${cssVars.fg_gray1_white};
    position: relative;
    margin-bottom: 8px;
    ${Text.Full.large.semibold};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

    ${Screen.ipad} {
        margin-bottom: 12px;
    }

    ${Screen.desktop} {
        margin-bottom: 16px;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const Location = styled.span`
    display: flex;
    color: ${cssVars.fg_gray2_gray3};
    margin-bottom: 8px;

    ${Text.Mobile.normal.regular}
    ${Screen.ipad} {
        margin-bottom: 12px;
        ${Text.Desktop.medium.regular}
    }

    ${Screen.desktop} {
        margin-bottom: 16px;
    }
`;

export const Description = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    margin-bottom: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    ${Text.Full.medium.regular};
    ${Screen.desktop} {
        margin-bottom: 16px;
    }
`;

export const BottomWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: ${borders.small} ${cssVars.bg_gray4_dark2};
    padding: 20px 0;
    margin: 0 8px;

    > button {
        background-color: transparent;
        color: ${Palette.green.normal};
        border-color: ${Palette.green.normal};
        &:hover {
            background-color: ${Palette.green.normal};
            color: ${Palette.white.normal};
            cursor: pointer;
            ${Transition.normal};
        }
    }
    ${Screen.ipad} {
        margin: 0 12px;
    }

    ${Screen.desktop} {
        margin: 0 16px;
    }
`;

export const Address = styled.div`
    margin: 12px 0;
    color: ${cssVars.fg_gray2_gray3};

    > svg {
        height: 12.5px;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;

    ${Screen.ipad} {
        width: 35%;
    }

    ${Screen.desktop} {
        width: 45%;
    }
`;

export const ExperienceText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border: ${borders.small} ${Palette.green.normal};
    height: 50px;
    border-radius: ${radius.large};
    padding: 10px 15px;
    color: ${Palette.green.normal};
`;

export const RatingWrapper = styled.div`
    display: flex;
    color: ${cssVars.fg_gray2_gray3};

    ${Screen.desktop} {
        align-items: center;
        padding: 0px 10px 6px 11px;
    }
`;

export const BeFirst = styled.div`
    color: ${Palette.sand.darkSand};
`;

export const RatingText = styled.span`
    margin: 0 auto 0 6px;
`;
